/**
 * Plano de Ação — visão DESKTOP (avaliadores/gestão), dentro do dashboard: o
 * cabeçalho padrão da página + a visão do avaliador compartilhada com o mobile
 * (`components/plano/PlanoAvaliador`), que é a estrutura do Portal da Unidade com
 * a camada de revisão.
 */
import { PlanoAvaliador } from "../../components/plano/PlanoAvaliador.tsx";
import { PageHeader } from "../ui/kit.tsx";

export interface PlanoAcaoDesktopProps {
  avaliacaoId: string | null;
  token: string | null;
  onBack: () => void;
}

export function PlanoAcaoDesktop({ avaliacaoId, token, onBack }: PlanoAcaoDesktopProps) {
  return (
    <>
      <PageHeader
        titulo="Plano de Ação"
        sub="FACR · achados de maturidade 0–2"
        acoes={
          <button type="button" className="m-btn" onClick={onBack}>
            Voltar
          </button>
        }
      />
      <PlanoAvaliador avaliacaoId={avaliacaoId} token={token} />
    </>
  );
}
